import { Box, Columns, Column, Divider, Text } from 'braid-design-system';


export const SocialDivider = () => {
  return (
    <Box paddingBottom="large" paddingTop="large">
      <Columns space="small" alignY="center">
        <Column>
          <Divider />
        </Column>
        <Column width="content">
          <Text tone="secondary" align="center">
            {'or'}
          </Text>
        </Column>
        <Column>
          <Divider />
        </Column>
      </Columns>
    </Box>
  );
};
